import styled from 'styled-components'
import { CSVLink } from 'react-csv'

export const StyledWrapper = styled.span``

export const StyledLoadingWrapper = styled.span`
  & > section {
    padding: 0px !important;
    & > span {
      margin-top: 0px !important;
    }
  }
`

export const StyledButton = styled.span`
  display: flex;
`

export const StyledDownloadLink = styled(CSVLink)``
